var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reactions-container" },
    [
      _c(
        "transition-group",
        { attrs: { name: "screenReactions" } },
        _vm._l(_vm.screenReactions, function (reaction) {
          return _c(
            "span",
            {
              key: reaction.id,
              staticClass: "reaction",
              style: reaction.style,
              attrs: {
                role: "img",
                "aria-label": _vm.iconsTypes[reaction.type].value,
              },
            },
            [_vm._v(" " + _vm._s(_vm.iconsTypes[reaction.type].emoji) + " ")]
          )
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }